import clsx from 'clsx';
import { Maybe, fromEmpty, just, nothing } from 'maybeasy';
import { observer } from 'mobx-react';
import { Avatar, avatarFrom } from '../../../../../../../Avatar';
import CloseIcon from '../../../../../../Cutesies/CloseIcon';
import ParticipantAvatar from '../../../../../../ParticipantAvatar';
import { SuccessfulParticipant } from '../../../../Store/Types';
import AddParticipantsToGroupFormStore from '../Store';

interface Props {
  participant: SuccessfulParticipant;
  addParticipantsToGroupFormStore: AddParticipantsToGroupFormStore;
}

const maybeInitials = (participant: SuccessfulParticipant): Maybe<string> =>
  just({})
    .assign(
      'firstInitial',
      fromEmpty(participant.firstName).map((name) => name.charAt(0)),
    )
    .assign(
      'lastInitial',
      fromEmpty(participant.lastName).map((name) => name.charAt(0)),
    )
    .map(({ firstInitial, lastInitial }) => `${firstInitial}${lastInitial}`);

const getAvatar = (participant: SuccessfulParticipant): Avatar =>
  avatarFrom(nothing(), maybeInitials(participant));

function Participant({ participant, addParticipantsToGroupFormStore }: Props) {
  return (
    <div className="flex pt-2 mr-4 my-4 justify-between items-center" key={participant.email}>
      <div className="flex">
        <div className="w-8 h-8 mr-2 my-auto">
          <div
            className={clsx(
              'block',
              'min-h-full min-w-full',
              'max-w-full max-h-full',
              'bg-black rounded-full',
              'text-white text-center leading-8',
            )}
          >
            <ParticipantAvatar avatar={getAvatar(participant)} />
          </div>
        </div>
        <div className="flex flex-col">
          <div className="text-sm">
            {participant.firstName} {participant.lastName}
          </div>
          <div className="text-xs">{participant.email}</div>
        </div>
      </div>
      <div
        className="cursor-pointer"
        onClick={() => {
          addParticipantsToGroupFormStore.removeParticipant(participant);
        }}
      >
        <CloseIcon variant="small" />
      </div>
    </div>
  );
}

export default observer(Participant);
